import React from "react";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from "@mui/icons-material/Delete";
import { StyledActionRenderer } from "./styles";
export const ActionRenderer = (params) => {
  const { onEdit = () => {}, onDelete = () => {}, data,showDeleteIcon,showEditIcon } = params;
  return (
    <StyledActionRenderer>
      {showEditIcon && <button
        className="tma_action_icon edit"
        onClick={() => {
          onEdit(data);
        }}
      >
        <BorderColorIcon titleAccess="Edit Row" />
      </button>}
      {showDeleteIcon && <button className="tma_action_icon delete" onClick={()=>onDelete(data)}>
        <DeleteIcon titleAccess="Delete Row" />
      </button>}
    </StyledActionRenderer>
  );
};
